import { render, staticRenderFns } from "./Newslettercontact.vue?vue&type=template&id=7436ba6c&"
import script from "./Newslettercontact.vue?vue&type=script&lang=js&"
export * from "./Newslettercontact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7436ba6c')) {
      api.createRecord('7436ba6c', component.options)
    } else {
      api.reload('7436ba6c', component.options)
    }
    module.hot.accept("./Newslettercontact.vue?vue&type=template&id=7436ba6c&", function () {
      api.rerender('7436ba6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Newslettercontact.vue"
export default component.exports